// Should stay in sync with SurveyResultValuePresentation.cs
const SURVEY_VALUE_PRESENTATION_TYPE = {
  Percentage: 0,
  SignedInteger: 1,
  UnsignedInteger: 2
};

export default SURVEY_VALUE_PRESENTATION_TYPE;
